import type { AppActivity, NetworkAvailability } from '../ports';
import type { PortalClient } from './portalClient';

export type RealtimeLifecycleClient = Pick<PortalClient, 'connect' | 'ensureAlive' | 'connection'>;

export type RealtimeLifecycleOptions = {
  client: RealtimeLifecycleClient;
  networkAvailability?: NetworkAvailability;
  appActivity?: AppActivity;
  onResume?: () => void;
};

export function startRealtimeLifecycle({
  client,
  networkAvailability,
  appActivity,
  onResume,
}: RealtimeLifecycleOptions): () => void {
  let inactiveSince: number | null = null;

  const unsubscribeFromActivity = appActivity?.subscribe((isActive) => {
    if (!isActive) {
      inactiveSince ??= Date.now();
      return;
    }

    const inactiveForMs = inactiveSince === null ? null : Date.now() - inactiveSince;
    inactiveSince = null;
    onResume?.();
    void client.ensureAlive(inactiveForMs);
  });

  const unsubscribeFromNetwork = networkAvailability?.subscribe((isOnline) => {
    if (isOnline && client.connection.getSnapshot().status !== 'connected') {
      client.connect();
    }
  });

  return () => {
    unsubscribeFromActivity?.();
    unsubscribeFromNetwork?.();
  };
}
